<template>
  <div id="popup">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px">
              <el-form-item :label="$t('interaction.name')" >
                <el-input v-model="filterForm.title" :placeholder="$t('interaction.enterName')" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item :label="$t('interaction.status')" >
                <el-select
                  v-model="filterForm.status"
                  :placeholder="$t('interaction.chooseStatus')"
                >
                  <el-option
                    key="1"
                    label="未启用"
                    value="0"
                  >
                  </el-option>
                  <el-option
                    key="0"
                    label="启用"
                    value="1"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('interaction.startTime')" >
                <el-date-picker
                  style="width: 100%"
                  v-model="filterForm.startDate"
                  type="date"
                  :placeholder="$t('survey.startTime')"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('interaction.endTime')" >
                <el-date-picker
                  style="width: 100%"
                  v-model="filterForm.endDate"
                  type="date"
                  :placeholder="$t('survey.startTime')"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="20">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
                  <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="filterBtns">
                  <el-button type="primary" @click="openAdd">{{ $t('new') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table :data="tableData" v-loading="tableLoading">
              <el-table-column sortable prop="title" :label="$t('interaction.name')" width="300"></el-table-column>
              <el-table-column sortable prop="usageStatus" :label="$t('interaction.status')"></el-table-column>
              <el-table-column sortable prop="startDate" :label="$t('interaction.startTime')"></el-table-column>
              <el-table-column sortable prop="endDate" :label="$t('interaction.endTime')"></el-table-column>
              <el-table-column :label="$t('operation')">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="openEdit(scope.row)">{{ $t('edit') }}</el-button>
                  <el-button type="text" size="mini" @click="deletePopup(scope.row.id)">{{ $t('delete') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 编辑 -->
    <el-dialog
      :title=" popupTitle + '弹窗'"
      :visible.sync="dialogVisible"
      width="50%"
      center
      :before-close="handleClose">
      <el-form :model="ruleForm" label-width="120px">
        <el-form-item label="名称:" prop="title">
          <el-input v-model="ruleForm.title" placeholder="请输入名称" maxlength="100"></el-input>
        </el-form-item>

        <el-form-item label="开始日期:" prop="startDate">
          <el-date-picker
            v-model="ruleForm.startDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="结束日期:" prop="endDate">
          <el-date-picker
            v-model="ruleForm.endDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="每天开始时间:" prop="everydayStartTime">
          <el-time-picker
            v-model="ruleForm.everydayStartTime"
            value-format="HH:mm:ss"
            placeholder="00:00:00">
          </el-time-picker>
        </el-form-item>

        <el-form-item label="每天次数:" prop="showCount">
          <el-input-number v-model="ruleForm.showCount" :min="1" label=""></el-input-number>
        </el-form-item>

        <el-form-item label="启用:" prop="usageStatus">
          <el-switch
            v-model="ruleForm.usageStatus"
            active-color="#67C23A"
          >
          </el-switch>
        </el-form-item>

        <anyImageUpload
          label="图片"
          labelWidth="120"
          v-model="ruleForm.imageUrl"
          :type="2"
          text="图片大小为650*960,格式为jpg或png"
        />

        <!--        <el-form-item label="targetUrl:" prop="targetUrl">-->
        <!--          <el-input v-model="ruleForm.targetUrl" placeholder="请输入targetUrl"></el-input>-->
        <!--        </el-form-item>-->

        <!--        <el-form-item label="targetId:" prop="targetId">-->
        <!--          <el-input v-model="ruleForm.targetId" placeholder="请输入targetId"></el-input>-->
        <!--        </el-form-item>-->

        <el-form-item label="所属系统:" prop="businessSystem">
          <el-select
            v-model="ruleForm.businessSystem"
            style="width: 100%"
            clearable
            placeholder="请选择所属系统"
          >
            <el-option
              v-for="(item, index) in typeOptions"
              :key="index"
              :value="item.value"
              :label="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>


      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitPopup">保 存</el-button>
        <el-button type="primary" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import anyImageUpload from "@/components/anyImageUpload";

export default {
  name: 'Popup',
  components: {
    anyImageUpload
  },
  data: function () {
    return {
      popupTitle: '',
      imageUrl: "", //大图
      initRuleForm: {
        endDate: '',
        everydayStartTime: '00:00:00',
        id: 0,
        imageUrl: '',
        showCount: '',
        startDate: '',
        targetId: '',
        targetUrl: '',
        title: '',
        businessSystem: '',
        usageStatus: false
      },
      ruleForm: {

      },
      filterForm: {
        title: '', // 名称
        status: '', // 状态
        startDate: '', // 开始时间
        endDate: '', // 结束时间
      },
      initFilterForm: {
        title: '', // 名称
        status: '', // 状态
        startDate: '', // 开始时间
        endDate: '', // 结束时间
      },
      loading: false,
      dialogVisible: false, // 弹框显示
      tableData: [], // 表格数据
      total: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
      formLabelWidth: '120px',
      typeOptions: [],
    }
  },
  mounted () {
    this.getTypeOptions()
  },

  methods: {
    async getTypeOptions() {
      let res = await window.instance.post(window.retailinkUrl + '/mqApi/systemType')
      res = res.data
      if (res.code === 200) {
        this.typeOptions = _.map(res.data, (type) => ({
          key: type.desc,
          value: type.code
        }))
      }
    },
    async getData(id) {
      let res = await window.instance.get(window.retailinkUrl + '/popup/getPopup/' + id)
      res = res.data
      if (res.code === 200) {
        this.ruleForm = _.cloneDeep(res.data)
        this.ruleForm.usageStatus = !!this.ruleForm.usageStatus
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    onReset() {
      // 重置
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },
    async submitPopup(){
      let submitUrl
      if (this.ruleForm.id) {
        submitUrl = '/popup/updPopup'
      } else {
        submitUrl = '/popup/insertPopup'
      }
      /*if (this.ruleForm.everydayStartTime) {
        this.ruleForm.everydayStartTime = _.toString(new Date(this.ruleForm.everydayStartTime)).split(' ')[4];
      }*/
      let submitData = _.cloneDeep(this.ruleForm);
      _.assignIn(submitData, {usageStatus: submitData.usageStatus ? 1 : 0})
      let res = await window.instance.post(window.retailinkUrl + submitUrl, submitData);
      res = res.data
      if (res.code === 200) {
        this.$message.success(res.message)
        this.dialogVisible = false;
        await this.onSearch(true);
      }
    },

    deletePopup(id) {
      this.$confirm('确定删除该弹窗吗?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await window.instance.post(window.retailinkUrl + '/popup/delPopup/' + id)
        res = res.data
        if (res.code === 200) {
          this.onSearch(true)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    openAdd () {
      this.dialogVisible = true
      this.popupTitle = '新增'
      this.ruleForm = _.cloneDeep(this.initRuleForm)
    },
    openEdit (row) {
      this.dialogVisible = true
      this.popupTitle = '编辑'
      this.getData(row.id)
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      let res = await window.instance.post(window.retailinkUrl + '/popup/listPopup', _.assign(this.filterForm, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.records
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
  }
}
</script>

<style scoped lang="sass">
#popup

</style>



// WEBPACK FOOTER //
// src/pages/interaction/popup.vue